import React, { useEffect, useState } from "react";

import Close from "../../Assets/Close.svg";
import RightSidebarStyle from "./style";
// -- redux
import { connect } from "react-redux";
import { ServiceRequestDetails } from "../../Redux/Actions/ServiceRequestAction";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-regular-svg-icons";
//import Loader from "../../Container/Loader";
import { withRouter } from "react-router";
import Modal from "../../Container/Modal";
function RightSideBar(props) {
  const [cameraModal, setCameraModal] = useState("");

  const CloseSidebar = (e) => {
    e.preventDefault();
    props.close();
  };

  useEffect(() => {
    if (props.data && props.data.id) {
      const body = {
        id: props.data.id,
      };
      props.sidebar && props.ServiceRequestDetails(body);
    }
    //alert(JSON.stringify(props.details_data.data[0].files[0]));
    // alert(JSON.stringify(props.details_data));
  }, [props.data]);

  return (
    <>
      {cameraModal !== "" && (
        <Modal
          Type={"Camera-Modal"}
          cameraUrl={cameraModal}
          CloseModal={() => setCameraModal("")}
        />
      )}

      {props && props.sidebar && (
        <div onClick={(e) => CloseSidebar(e)} className="overlay" />
      )}
      <div
        className={
          props && props.sidebar
            ? "dark-background right-sidebar-wrap"
            : "dark-background right-sidebar-wrap right-sidebar-wrap-close"
        }
      >
        <div className="d-flex justify-content-between align-items-center">
          {props.data && props.data.title && (
            <h5 className="text-uppercase text-white mb-4">
              {props.data.title}
            </h5>
          )}
          <img
            onClick={(e) => CloseSidebar(e)}
            src={Close}
            alt="Close"
            className="cursor-pointer"
          />
        </div>
        <form className="sidebar-form-wrap" id="SidebarForm">
          {props.details_data &&
          props.details_data.data &&
          props.details_data.data.length > 0 ? (
            props.details_data &&
            props.details_data.data &&
            props.details_data.data.map((question, index) => {
              return (
                <div className="mb-4" key={index}>
                  <label className="text-grey-5 f-16 d-block mb-1">
                    {/* Not used below */}
                    {question.question !== "Please upload your photo"
                      ? question.question
                      : "Camera Photo"}
                  </label>
                  <label className="f-16 text-white d-block mb-1">
                    {/* Dont think question.question_type is even a field */}
                    {question.question_type === 7
                      ? question.answer
                          .split(",")
                          .map((data) => <div>{data}</div>)
                      : question.answer}
                  </label>
                  {question.images.length > 0 ? (
                    <div className="fxd-row">
                      {question.images.map((item, index) => {
                        return (
                          <div className="fxd-row mr-3 p-1 border-grey-1 cursor-pointer ">
                            <img
                              width={50}
                              height={50}
                              onClick={() => setCameraModal(item.image)}
                              src={item.image}
                              alt={`img_${item.id}`}
                            />
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    question.files &&
                    question.files.length > 0 && (
                      <div className="fxd-row">
                        {question.files.map((file, index) => (
                          <div
                            className="fxd-row mr-3 p-1 border-grey-1 cursor-pointer"
                            key={index}
                          >
                            <FontAwesomeIcon
                              icon={faFileExcel}
                              style={{
                                color: "#bdff00",
                                marginRight: "2px",
                                height: "20px",
                                width: "20px",
                              }}
                            />
                            <a
                              href={`data:application/octet-stream;base64,${file.data}`}
                              download={file.file}
                            >
                              {file.file}
                            </a>
                          </div>
                        ))}
                      </div>
                    )
                  )}
                </div>
              );
            })
          ) : (
            <div className="mt-5 text-center">
              <h5 className="text-white">No data found</h5>
            </div>
          )}
        </form>
      </div>
      <RightSidebarStyle />
    </>
  );
}

const mapStateToProps = ({ ServiceRequestReducer }) => {
  const { loading, details_data } = ServiceRequestReducer;
  return { loading, details_data };
};

const mapDispatchToProps = {
  ServiceRequestDetails,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(RightSideBar));
